import { createPermissionObject, } from './permissionObject';
import { getMissingPermissionTypes, matchAllPermissionTypes, PermissionType, } from './permissionType';
/**
 * Verify permissions are met
 * @param permissions all permissions the user has
 * @param requiredPermissions permissions that need to match (including all types)
 */
export function matchAllPermissions(permissions, requiredPermissions) {
    for (const required of requiredPermissions) {
        if (!permissions.find((o) => o.permission === required.permission &&
            matchAllPermissionTypes(o.types, required.types))) {
            return false;
        }
    }
    return true;
}
export function matchOnePermission(permissions, oneOfPermissions) {
    for (const permission of oneOfPermissions) {
        if (permissions.find((o) => o.permission === permission.permission &&
            matchAllPermissionTypes(o.types, permission.types))) {
            return true;
        }
    }
    return false;
}
export function getMissingPermissions(permissions, requiredPermissions) {
    const missing = [];
    for (const required of requiredPermissions) {
        const found = permissions.find((o) => o.permission === required.permission);
        const missingTypes = found
            ? getMissingPermissionTypes(found.types, required.types)
            : required.types;
        if (found && missingTypes.length === 0)
            continue;
        missing.push(createPermissionObject(required.permission, missingTypes));
    }
    return missing;
}
// quick access to check a session or a permission object array for a single permission and permission type
export function checkPermission(obj, permission, type = PermissionType.READ) {
    const permissions = Array.isArray(obj) ? obj : [];
    return matchAllPermissions(permissions, [
        createPermissionObject(permission, [type]),
    ]);
}
export function permissionsToString(permissions) {
    return permissions
        .map((p) => `${p.permission} (${p.types.join(', ')})`)
        .join(', ');
}
